// d88a0b5e33a0fc9e3ecff4452e7a717a9acf33cd|kind=parser-js|name=Industry|schemaHash=7fab2b050967201ae7cd90da3a3615ca17ae693a

import { setDefinedValue } from '@myre/common-primitives';

export function parseIndustryFromJSON(
  _data,
) {
  if (!_data) {
    return _data;
  }

  const result = {};

  setDefinedValue(result, 'label', _data.label);
  setDefinedValue(result, 'id', _data.id);

  return result;
}

export function parseIndustryToJSON(
  _data,
) {
  if (!_data) {
    return _data;
  }

  const result = {};

  setDefinedValue(result, 'label', _data.label);
  setDefinedValue(result, 'id', _data.id);

  return result;
}
